import React from 'react'
import AccountPage from 'scenes/Account/AccountPage.component'
import { ResetPasswordForm } from 'scenes/Account/components/ResetPasswordForm'

class ResetPassword extends React.PureComponent {
  render() {
    return (
      <AccountPage title="Account recovery">
        <ResetPasswordForm />
      </AccountPage>
    )
  }
}

export default ResetPassword
